import { Button } from "@material-ui/core";
import React, { useState } from "react";
import EmailUsCss from "./style";
import axiosInstance from "../../config/axios";
import CircularProgress from "@material-ui/core/CircularProgress";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";

const EmailUs = props => {
  const [email, setEmail] = useState("");
  const [processing, setProcessing] = useState(false);
  const [toastOpen, setToastOpen] = useState(false);
  // const [status, setStatus] = useState(0);
  const [statusCode, setStatusCode] = useState(0);
  const handleSubmit = e => {
    e.preventDefault();
    console.log(email);
    setProcessing(true);
    setStatusCode(0);

    axiosInstance
      .post("/api/subscribe/", { email: email })
      .then(res => {
        // setStatus(1);
        setProcessing(false);
        setEmail("");
        setToastOpen(true);
        setStatusCode(res.status);
        // localStorage.setItem("subscribed", true);
      })
      .catch(error => {
        console.log("error", error.data.error);
        setProcessing(false);
        setToastOpen(true);
      });
  };
  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setToastOpen(false);
  };

  return (
    <EmailUsCss>
      <div className="wrapper">
        <div className="signup">
          <div className="top">
            <div
              className="text"
              style={{ borderRight: "1px solid rgba(253, 205, 11, 0.1)" }}
            >
              From the team that brought you the CETO Blockchain Family
            </div>
            <div className="text">
              Sign up for email updates from the CETO Foundation
            </div>
          </div>

          <div className="middle">
            <div className="left">
              <img
                src="features/CETO.png"
                alt="ceto"
                style={{ cursor: "pointer" }}
                onClick={() =>
                  window.open(
                    "https://sandbox.crystalelephant.net/ceto/buy",
                    "_blank"
                  )
                }
              />
              <img
                src="features/BCETO.png"
                alt="bceto"
                style={{ cursor: "pointer" }}
                onClick={() =>
                  window.open(
                    "https://sandbox.crystalelephant.net/bceto/buy",
                    "_blank"
                  )
                }
              />
              <img
                src="features/ECETO.png"
                alt="eceto"
                style={{ cursor: "pointer" }}
                onClick={() =>
                  window.open(
                    "https://sandbox.crystalelephant.net/eceto/buy",
                    "_blank"
                  )
                }
              />
            </div>
            <div
              className="right"
              style={{ borderLeft: "1px solid rgba(253, 205, 11, 0.1)" }}
            >
              <img
                className="image"
                src="features/foundation.png"
                alt="foundation"
                style={{ cursor: "pointer" }}
                onClick={() =>
                  window.open("https://crystalelephant.net/", "_blank")
                }
              />
            </div>
          </div>

          <div className="bottom">
            <div
              className="left"
              style={{ borderRight: "1px solid rgba(253, 205, 11, 0.1)" }}
            >
              {props.match.path !== "/harvestround" &&
                props.match.path !== "/combineround" && (
                  <Button
                    style={{ textTransform: "none" }}
                    variant="contained"
                    className="discussBtn"
                    onClick={() =>
                      window.open("https://discord.gg/Qek3eMeHDk", "_blank")
                    }
                  >
                    Discuss on Discord
                  </Button>
                )}
            </div>
            <div className="right">
              <form action="submit" onSubmit={handleSubmit}>
                <input
                  type="email"
                  className="inputField"
                  required
                  placeholder="Enter email address"
                  value={email}
                  onChange={e => setEmail(e.target.value)}
                />
                <button type="submit" className="submitButton">
                  {!processing && (
                    <img src="features/rightArrow.png" alt="sendmail" />
                  )}
                  {processing && (
                    <CircularProgress className="circle" size="22px" />
                  )}
                </button>
              </form>
              <Snackbar
                anchorOrigin={{
                  vertical: "top",
                  horizontal: "center",
                }}
                open={toastOpen}
                autoHideDuration={3000}
                onClose={handleClose}
                key="top-center"
              >
                <MuiAlert
                  elevation={6}
                  variant="filled"
                  onClose={handleClose}
                  severity={statusCode === 200 ? "success" : "error"}
                >
                  {statusCode === 200
                    ? "Signed Up Successfully!"
                    : "Some technical error occured."}
                </MuiAlert>
              </Snackbar>
            </div>
          </div>
        </div>

        <div className="mobile">
          <div className="up">
            <div className="top">
              <div className="text">
                From the team that brought you the CETO Blockchain Family
              </div>
            </div>
            <div className="middle">
              <div className="images">
                <img
                  className="image"
                  src="features/CETO.png"
                  alt="ceto"
                  style={{ cursor: "pointer" }}
                  onClick={() =>
                    window.open(
                      "https://sandbox.crystalelephant.net/ceto/buy",
                      "_blank"
                    )
                  }
                />
                <img
                  className="image"
                  src="features/BCETO.png"
                  alt="bceto"
                  style={{ cursor: "pointer" }}
                  onClick={() =>
                    window.open(
                      "https://sandbox.crystalelephant.net/bceto/buy",
                      "_blank"
                    )
                  }
                />
                <img
                  className="image"
                  src="features/ECETO.png"
                  alt="eceto"
                  style={{ cursor: "pointer" }}
                  onClick={() =>
                    window.open(
                      "https://sandbox.crystalelephant.net/eceto/buy",
                      "_blank"
                    )
                  }
                />
              </div>
            </div>
            <div className="bottom">
              <div className="btnDiv">
                {props.match.path !== "/harvestround" &&
                  props.match.path !== "/combineround" && (
                    <Button
                      style={{ textTransform: "none" }}
                      variant="contained"
                      className="discussBtn"
                      onClick={() =>
                        window.open("https://discord.gg/Qek3eMeHDk", "_blank")
                      }
                    >
                      Discuss on Discord
                    </Button>
                  )}
              </div>
            </div>
          </div>
          <div className="down">
            <div className="top">
              <div className="text">
                Sign up for email updates from the CETO Foundation
              </div>
            </div>
            <div className="middle">
              <div className="images">
                <img
                  className="image"
                  src="features/foundation.png"
                  alt="foundation"
                  style={{ cursor: "pointer" }}
                  onClick={() =>
                    window.open("https://crystalelephant.net/", "_blank")
                  }
                />
              </div>
            </div>
            <div className="bottom">
              <div className="emaildiv">
                <form action="submit" onSubmit={handleSubmit}>
                  <input
                    type="email"
                    className="inputField"
                    required
                    placeholder="Enter email address"
                    value={email}
                    onChange={e => setEmail(e.target.value)}
                  />

                  <button type="submit" className="submitButton">
                    {!processing && (
                      <img src="features/rightArrow.png" alt="sendmail" />
                    )}
                    {processing && (
                      <CircularProgress className="circle" size="22px" />
                    )}
                  </button>
                </form>
                <Snackbar
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "center",
                  }}
                  open={toastOpen}
                  autoHideDuration={3000}
                  onClose={handleClose}
                  key="top-center"
                >
                  <MuiAlert
                    elevation={6}
                    variant="filled"
                    onClose={handleClose}
                    severity={statusCode === 200 ? "success" : "error"}
                  >
                    {statusCode === 200
                      ? "Signed Up Successfully!"
                      : "Some technical error occured."}
                  </MuiAlert>
                </Snackbar>
              </div>
            </div>
          </div>
        </div>
      </div>
    </EmailUsCss>
  );
};

export default EmailUs;
